import type { IndustryPack } from "./types";
import packsDoc from "./packs.json";

/** Industry packs and topic terms. Master list is `packs.json` (BFF loads the same file). */
export const industryPacks: IndustryPack[] = packsDoc.packs as IndustryPack[];

export function getPack(packId: string): IndustryPack | undefined {
  return industryPacks.find((p) => p.packId === packId);
}

export function getTopic(pack: IndustryPack, topicId: string) {
  return pack.topics.find((t) => t.topicId === topicId);
}
